import { connect } from 'react-redux';

import { changeVariantQuantity } from '../actions';
import VariantPendingQuantityInput from '../components/VariantPendingQuantityInput';
import {
  getLineItemQuantitySaved,
  getLineItemQuantityPending,
} from 'apps/cart/selectors';

const mapStateToProps = (state, props) => {
  return {
    defaultQuantity: props.defaultQuantity,
    order: state.currentOrder,
    quantityPending: getLineItemQuantityPending(state, props),
    quantitySaved: getLineItemQuantitySaved(state, props),
  };
};

const mapDispatchToProps = dispatch => ({
  changeVariantQuantity: (variant, quantity, offeringId) =>
    dispatch(changeVariantQuantity(variant, quantity, offeringId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VariantPendingQuantityInput);
